import {
    BaseFileInformation,
    FileType,
    AttachmentFileInformation,
    CloudAttachmentFileInformation,
    SharePointFileInformation,
} from 'owa-group-files-hub-store';
import AttachmentId from 'owa-service/lib/contract/AttachmentId';
import AttachmentUrlType from 'owa-files-url/lib/schema/AttachmentUrlType';
import {
    getAttachmentUrlForClassic,
    getAttachmentUrlForCloudy,
} from 'owa-files-url/lib/actions/getAttachmentUrl';
import createSharePointDownloadUrl from './createSharePointDownloadUrl';
import { getGroupResourceUrl } from 'owa-groups-shared-store';

export default function getFileDownloadUrl(fileInformation: BaseFileInformation): string {
    switch (fileInformation.fileType) {
        case FileType.ClassicAttachment:
            const attachmentfileInfo = fileInformation as AttachmentFileInformation;
            const attachmentId: AttachmentId = {
                Id: attachmentfileInfo.attachmentId,
            };
            return getAttachmentUrlForClassic(
                attachmentfileInfo.groupSmtpAddress,
                attachmentId,
                AttachmentUrlType.FullFile
            );
        case FileType.CloudAttachment:
            const cloudfileInfo = fileInformation as CloudAttachmentFileInformation;
            const cloudAttachmentId: AttachmentId = {
                Id: cloudfileInfo.attachmentId,
            };
            return getAttachmentUrlForCloudy(
                cloudAttachmentId,
                cloudfileInfo.url,
                AttachmentUrlType.FullFile,
                true
            );
        case FileType.SharePointFile:
            const sharePointfileInfo = fileInformation as SharePointFileInformation;
            return createSharePointDownloadUrl(
                getGroupResourceUrl(sharePointfileInfo.groupSmtpAddress, 'Site'),
                sharePointfileInfo.id
            );
        default:
            return null;
    }
}
